import React, { useState } from 'react';
import { CloseIcon, LocationIcon } from '../Icons/Icons';
import './MapsPreview.css';

function MapsPreview({ onClose }) {
  const [selectedCity, setSelectedCity] = useState('Karachi');

  const cities = {
    Karachi: {
      name: 'Karachi',
      coordinates: '24.8607° N, 67.0011° E',
      popularAreas: [
        { name: 'DHA Phase 6', properties: 2847, avgPrice: 'PKR 1.2 Cr' },
        { name: 'Clifton', properties: 1923, avgPrice: 'PKR 1.5 Cr' },
        { name: 'Bahria Town', properties: 3412, avgPrice: 'PKR 95 Lac' },
        { name: 'Gulistan-e-Jauhar', properties: 2156, avgPrice: 'PKR 75 Lac' }
      ]
    },
    Lahore: {
      name: 'Lahore',
      coordinates: '31.5204° N, 74.3587° E',
      popularAreas: [
        { name: 'DHA Phase 5', properties: 3124, avgPrice: 'PKR 1.1 Cr' },
        { name: 'Gulberg', properties: 2567, avgPrice: 'PKR 85 Lac' },
        { name: 'Bahria Town', properties: 4231, avgPrice: 'PKR 72 Lac' },
        { name: 'Johar Town', properties: 1843, avgPrice: 'PKR 68 Lac' }
      ]
    },
    Islamabad: {
      name: 'Islamabad',
      coordinates: '33.6844° N, 73.0479° E',
      popularAreas: [
        { name: 'F-7', properties: 1234, avgPrice: 'PKR 2.2 Cr' },
        { name: 'F-6', properties: 1567, avgPrice: 'PKR 1.8 Cr' },
        { name: 'Bahria Town', properties: 5432, avgPrice: 'PKR 1.2 Cr' },
        { name: 'G-11', properties: 2341, avgPrice: 'PKR 95 Lac' }
      ]
    }
  };

  const cityData = cities[selectedCity];

  return (
    <div className="maps-modal-overlay" onClick={onClose}>
      <div className="maps-modal" onClick={(e) => e.stopPropagation()}>
        <div className="maps-header">
          <h2>Maps & Locations</h2>
          <button className="btn-close" onClick={onClose} aria-label="Close maps">
            <CloseIcon size={24} color="#636e72" />
          </button>
        </div>

        <div className="maps-body">
          <div className="city-selector">
            {Object.keys(cities).map(city => (
              <button
                key={city}
                className={`city-tab ${selectedCity === city ? 'active' : ''}`}
                onClick={() => setSelectedCity(city)}
              >
                {city}
              </button>
            ))}
          </div>

          <div className="map-container">
            <div className="map-placeholder">
              <LocationIcon size={64} color="var(--color-primary)" />
              <h3>{cityData.name}</h3>
              <p>{cityData.coordinates}</p>
              <div className="map-notice">
                Interactive map integration coming soon
              </div>
            </div>
          </div>

          <div className="popular-areas">
            <h3>Popular Areas in {cityData.name}</h3>
            <div className="areas-grid">
              {cityData.popularAreas.map((area, index) => (
                <div key={index} className="area-card">
                  <div className="area-header">
                    <LocationIcon size={20} color="var(--color-primary)" />
                    <h4>{area.name}</h4>
                  </div>
                  <div className="area-stats">
                    <div className="area-stat">
                      <span className="stat-label">Properties</span>
                      <span className="stat-value">{area.properties.toLocaleString()}</span>
                    </div>
                    <div className="area-stat">
                      <span className="stat-label">Avg Price</span>
                      <span className="stat-value">{area.avgPrice}</span>
                    </div>
                  </div>
                  <button className="btn-view-area">View Properties</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MapsPreview;
